window.addEventListener("load", function () {
  // Function to get URL parameters
  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Get UTM source if exists
  const utmSource = getURLParameter("utm_source") || "direct";

  // Track Privy form submissions
  document.querySelectorAll("#privy-submit-btn").forEach(function (e) {
    e.addEventListener("click", function (e) {
      gtag("event", "subscribe_submit", {
        subscription_method: "privy",
        source: utmSource,
      });
    });
  });

  // Track Klaviyo form submissions using their native event
  window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type === "submit") {
      gtag("event", "subscribe_submit", {
        subscription_method: "klaviyo",
        source: utmSource,
        // form_id: e.detail.formId,
        // form_title: e.detail.formTitle,
      });
    }
  });

  // Track footer newsletter form submissions
  document
    .querySelector("#footer-newsletter")
    .addEventListener("submit", function (e) {
      gtag("event", "subscribe_submit", {
        subscription_method: "footer_form",
        source: utmSource,
      });
    });

});
